import React from "react";

export const Feature = (props) => {
  return (
    <div id="feature">
      <div className="container">
        <div className="col-md-12 text-center">
          <img src="img/title-feature.png" className="img-title" alt="" />
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
              <div key={`${d.name}-${i}`} className="col-md-4 col-sm-4">
                <div className="feature">
                  <div>
                  </div>
                  <div className="feature-content">
                    <div className="feature-image">
                    {" "}
                    <img src={d.img} alt="" />{" "}
                    </div>
                    <div className="feature-meta">{d.name} </div>
                    <div><p>"{d.text}"</p></div>  
                  </div>
                </div>
              </div>
            ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
